import React from 'react';

export function Row({ children }) {
  return <div style={{ display: 'flex', flexDirection: 'row', flex: 1, gap: 8 }}>{children}</div>;
}
